import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { BooleanConverter } from '../../inputConverter';
import { LayerService } from '../../services/layer.service';
import { PetlService } from '../../services/petl.service';
import { PetlBaseComponent } from './petl-base.component';
var PetlComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlComponent, _super);
    function PetlComponent(_vcr, layerService, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.layerService = layerService;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this._enableMapFileDrop = true;
        _this.onfiledrop = new EventEmitter();
        _this.onpetlclose = new EventEmitter();
        _this.onpromote = new EventEmitter();
        _this.initialize = function () {
            _this.petlService.initialize();
            _this.detectChanges();
        };
        _this.startOver = function () {
            _this.petlService.startOver();
            _this.detectChanges();
        };
        _this.ondragenter = function (ev) {
            var validItems = ['excel', 'spreadsheet', 'text'];
            if (ev.dataTransfer.items && ev.dataTransfer.items.length) {
                var item_1 = ev.dataTransfer.items[0];
                if (validItems.filter(function (x) { return item_1.type.indexOf(x) >= 0; }).length > 0) {
                    ev.preventDefault();
                    _this.showMapDropOverlay(true);
                }
            }
        };
        _this.ondragover = function (ev) {
            ev.preventDefault();
        };
        _this.ondrop = function (ev) {
            ev.preventDefault();
            _this.showMapDropOverlay(false);
            if (_this.petlService.isValidFileDrop(ev)) {
                _this.onfiledrop.emit(true);
                _this.service.processFileDrop(ev);
            }
        };
        _this.hideOverlay = function () {
            _this.showMapDropOverlay(false);
        };
        _this.petlService.petlClose = _this.onpetlclose;
        _this.petlService.complete = _this.onpromote;
        _this.registerEvent('onfiledrop', _this.onfiledrop);
        _this.registerEvent('onpetlclose', _this.onpetlclose);
        _this.registerEvent('onpromote', _this.onpromote);
        return _this;
    }
    Object.defineProperty(PetlComponent.prototype, "zoomToLayer", {
        get: function () {
            return this.service.zoomToLayer;
        },
        set: function (value) {
            this.service.zoomToLayer = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlComponent.prototype, "enableMapFileDrop", {
        get: function () {
            return this._enableMapFileDrop;
        },
        set: function (value) {
            this._enableMapFileDrop = BooleanConverter(value);
            if (this._enableMapFileDrop) {
                this.setDefaultDropElement();
            }
            else {
                this.removeMapDropEvents();
            }
        },
        enumerable: true,
        configurable: true
    });
    PetlComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.initialize();
                        this.service.zoomToLayer = this.zoomToLayer;
                        if (!this.enableMapFileDrop) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setDefaultDropElement()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 3:
                        _a.mapView = _b.sent();
                        this.petlService.setupLayerEvents(this.mapView);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PetlComponent.prototype, "errorMessage", {
        get: function () {
            return this.petlService.errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlComponent.prototype, "isColumnMappingButtonDisabled", {
        get: function () {
            return this.isButtonDisabled('processor');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlComponent.prototype, "isValidationButtonDisabled", {
        get: function () {
            return this.isButtonDisabled('validate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlComponent.prototype, "isPromotedButtonDisabled", {
        get: function () {
            return this.isButtonDisabled('promoted');
        },
        enumerable: true,
        configurable: true
    });
    PetlComponent.prototype.setDefaultDropElement = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dropElement) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.dropElement = parent_1.mapView.container;
                        _a.label = 3;
                    case 3:
                        this.setupMapDropEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlComponent.prototype.setupMapDropEvents = function () {
        this.dropElement.addEventListener('dragenter', this.ondragenter);
        this.dropElement.addEventListener('drop', this.ondrop);
        this.dropElement.addEventListener('mouseover', this.hideOverlay);
        this.dropElement.addEventListener('dragend', this.hideOverlay);
        this.dropElement.addEventListener('dragleave', this.hideOverlay);
        this.dropElement.addEventListener('click', this.hideOverlay);
        this.dropElement.addEventListener('dragover', this.ondragover);
    };
    PetlComponent.prototype.removeMapDropEvents = function () {
        this.dropElement.removeEventListener('dragenter', this.ondragenter);
        this.dropElement.removeEventListener('drop', this.ondrop);
        this.dropElement.removeEventListener('mouseover', this.hideOverlay);
        this.dropElement.removeEventListener('dragend', this.hideOverlay);
        this.dropElement.removeEventListener('dragleave', this.hideOverlay);
        this.dropElement.removeEventListener('click', this.hideOverlay);
        this.dropElement.removeEventListener('dragover', this.ondragover);
    };
    PetlComponent.prototype.isButtonDisabled = function (viewName) {
        return this.currentView !== viewName && !(this.petlService.nonNormalViews.indexOf(this.currentView) >= 0 && this.petlService.previousView === viewName);
    };
    PetlComponent.prototype.closePetl = function () {
        this.showMapDropOverlay(false);
        this.onpetlclose.emit(true);
    };
    PetlComponent.prototype.showMapDropOverlay = function (show) {
        if (show === void 0) { show = true; }
        var opacity = show ? '0.7' : '1';
        this.dropElement.style.setProperty('opacity', opacity);
    };
    PetlComponent.prototype.clearError = function () {
        this.petlService.errorMessage = null;
    };
    return PetlComponent;
}(PetlBaseComponent));
export { PetlComponent };
